import axios from 'axios';
import { ProjectDocumentsModel } from 'app/edozvola/cases/project-documents/model/project-documents.model';
import { FileWrapper } from 'app/shared/model/shared.model';
import { FileUploadModel } from 'app/shared/file-upload/model/file-upload.model';

export const saveProjectDocument = async (idCase: string, projectDocument: ProjectDocumentsModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/project-document/${idCase}`, projectDocument)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchProjectDocuments = async (
  idCase: string,
  page: number,
  size: number,
  column: string,
  direction: string,
  caseInPreview: boolean
): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(`api/project-document/find-all/${idCase}?page=${page}&size=${size}&column=${column}&direction=${direction}&caseInPreview=${caseInPreview}`)
        .then(response => resolve(response.data));
    });
  }
};

export const deleteProjectDocument = async (idProjectDocument: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/project-document/${idProjectDocument}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getProjectDocument = async (idProjectDocument: string): Promise<ProjectDocumentsModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/project-document/${idProjectDocument}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyProjectDocument = async (idProjectDocument: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/project-document/copy/${idProjectDocument}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const moveOrderingUp = async (idProjectDocument: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/project-document/move-up/${idProjectDocument}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const moveOrderingDownProjectDocument = async (idProjectDocument: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/project-document/move-down/${idProjectDocument}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const uploadProjectDocumentFile = async (idProjectDocument: string, file: FileUploadModel): Promise<any> => {
  const formData: FormData = new FormData();

  formData.append('file', file.file);
  formData.append('fileName', file.fileName);
  formData.append('uuid', file.uuid);

  return await new Promise((resolve, reject) => {
    axios
      .post(`api/project-document/files/${idProjectDocument}`, formData)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchProjectDocumentAttachments = async (
  idProjectDocuments: string,
  page: number,
  size: number,
  column: string,
  direction: string,
  caseInPreview: boolean ,
): Promise<any> => {
  if (idProjectDocuments) {
    return await new Promise(resolve => {
      axios
        .get(
          `api/project-document/files/find-all/${idProjectDocuments}?page=${page}&size=${size}&column=${column}&direction=${direction}&caseInPreview=${caseInPreview}`,
        )
        .then(response => resolve(response.data));
    });
  }
};

export const deleteProjectDocumentAttachment = async (idProjectDocumentAttachment: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/project-document/files/delete-attachment/${idProjectDocumentAttachment}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const updateProjectDocumentAttachmentStatus = async (idProjectDocumentAttachment: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/project-document/files/update-status/${idProjectDocumentAttachment}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const previewProjectDocumentAttachment = async (idProjectDocumentAttachment: number): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/project-document/files/preview-attachment/${idProjectDocumentAttachment}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyProjectDocuments = async (caseUuid: string, caseUuidToCopyFrom: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/project-document/copy/${caseUuid}/${caseUuidToCopyFrom}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getProjectDocumentsVariant = async (caseUuid: string, caseInPreview: boolean): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/project-document-variant?caseInPreview=${caseInPreview}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
